import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { ProductCard } from '../ProductCard';
import { TireTrack } from '../TireTrack';
import { getFeaturedProducts, getShopProducts } from '../../../data/products';

/**
 * Four items from the shop, with the total count doing the work of
 * suggesting there is more.
 */
export function ShopPreview() {
  const featured = getFeaturedProducts();
  const total = getShopProducts().length;
  return <section aria-labelledby="shop-preview-heading" className="relative overflow-hidden bg-cream py-16 sm:py-24" data-id="element-285" data-mp="11p5wcvhs2qv1">
      <TireTrack variant="curve-right" className="absolute -left-24 top-1/3 h-[220px] w-[450px] -rotate-6" opacity={0.04} data-id="element-286" data-mp="nocwdv8pj3kj" />

      <div className="relative mx-auto max-w-container px-gutter-sm sm:px-gutter-md lg:px-gutter-lg" data-id="element-287" data-mp="rsug5uf2hgvb">
        <div className="flex flex-wrap items-end justify-between gap-6" data-id="element-288" data-mp="3ch8ow0yuritq">
          <div className="max-w-2xl" data-id="element-289" data-mp="3cijtg304gulw">
            <p className="mb-5 border-l-4 border-rust pl-3 text-sm font-black uppercase tracking-[0.2em] text-rust" data-id="element-290" data-mp="32lr9t8rue0cw">
              Looking for a new garage
            </p>
            <h2 id="shop-preview-heading" className="font-bebas text-5xl leading-[0.9] tracking-wide text-ink sm:text-6xl" data-id="element-291" data-mp="2xp0uinnv38sj">
              Low On Fuel Shop
            </h2>
            <p className="mt-4 max-w-prose text-lg leading-relaxed text-ink/80" data-id="element-292" data-mp="3lkvjmjr7jy5m">
              Our own tees, caps and snoods, plus one-off reclaimed pieces and
              handmade bits from makers near us. {total} on the walls today.
            </p>
          </div>

          <Link to="/shop" className="group inline-flex shrink-0 items-center gap-2 rounded-container border border-control px-5 py-3 text-sm font-bold text-ink transition-colors duration-200 ease-out-expo hover:bg-ink/5 focus:outline-none focus:ring-2 focus:ring-rust focus:ring-offset-2" data-id="element-293" data-mp="3v9vje5djaxkv">
            Visit the shop
            <ArrowRight className="h-4 w-4 transition-transform duration-200 ease-out-expo group-hover:translate-x-1 motion-reduce:transform-none" aria-hidden="true" data-id="element-294" data-mp="2wzds3gmid1g2" />
          </Link>
        </div>

        <ul className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-295" data-mp="35xzclhbjiqjh">
          {featured.map(product => <li key={product.id} className="flex" data-id="element-296" data-mp="3asd8rly111p7">
              <div className="flex-1" data-id="element-297" data-mp="3fq4yc9b78bq8">
                <ProductCard product={product} data-id="element-298" data-mp="3fp3qsete67d9" />
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}